import React from 'react';

import { Col, Tab, Tabs } from 'react-bootstrap';
import CustomContainer from '../../components/CustomContainer';
import DictionariesManagementComponent from '../../components/dictionary/DictionariesManagementComponent';
import { dictionaries } from './DictionariesComponentConfig';
import GlobalConfigComponent from '../../components/globalConfig/GlobalConfigComponent';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import { configurations } from './ConfigurationsComponentConfig';

const SettingsPage = () => {
  const { setLoader } = useLoaderContext();

  return (
    <>
      <CustomContainer title={'Ustawienia'}>
        <Col>
          <div>
            <Tabs mountOnEnter unmountOnExit id="adminActions">
              <Tab eventKey="main" title="Słowniki">
                <DictionariesManagementComponent
                  setLoader={setLoader}
                  dictionaries={dictionaries}
                />
              </Tab>
              <Tab eventKey="variables" title="Zmienne globalne">
                <GlobalConfigComponent setLoader={setLoader} />
              </Tab>
              <Tab eventKey="configurations" title="Konfiguracje">
                <DictionariesManagementComponent
                  setLoader={setLoader}
                  dictionaries={configurations}
                />
              </Tab>
            </Tabs>
          </div>
        </Col>
      </CustomContainer>
    </>
  );
};

export default SettingsPage;
